const cursussen = [
  'examentraining',
  'stoomcursus',
  'kerstvakantiecursus',
  'herexamentraining',
  'talentrainingen',
  'scholen',
  'solliciteren',
];

const noParamCategories = [
  'blog',
  'eindexamen-toolkit',
];

const noParamPaths = [
  '/',
  '/onze-cursussen',
];

const shouldHaveCursusParam = (url: URL) => {
  const path = url.pathname;
  if (noParamPaths.includes(path)) {
    return false;
  }
  const firstPart = path.split('/')[1];
  if (firstPart !== undefined && noParamCategories.includes(firstPart)) {
    return false;
  }

  return true;
};

const cursusFromURL = (url: URL) => {
  const firstPart = url.pathname.split('/')[1];
  return firstPart !== undefined && cursussen.includes(firstPart) ? firstPart : url.searchParams.get('cursus');
};

const updateURLParameter = (urlString: string, param: string, paramVal: string) => {
  const url = new URL(urlString);
  url.searchParams.set(param, paramVal);
  return url.toString();
};

const processLink = (el: HTMLAnchorElement, currentCursus: string) => {
  if (el.href.startsWith('/') || el.host === window.location.host) {
    const elURL = new URL(el.href, location.origin);
    const elCursus = cursusFromURL(elURL);

    if (elCursus === null && shouldHaveCursusParam(elURL)) {
      el.href = updateURLParameter(el.href, 'cursus', currentCursus);
    }
  }
};

export const initCursusUrl: DrupalBehaviorHooks['attach'] = (context) => {
  const currentPage = new URL(location.href);
  const cursus = cursusFromURL(currentPage);

  if (cursus !== null && shouldHaveCursusParam(currentPage)) {
    context.querySelectorAll('a').forEach((el) => {
      processLink(el, cursus);
    });
  };
};
